<template>
    <Main>
        <div slot="main" class="main user">
            <div class="bank_title">
                <!-- 顶部 -->
                <div class="bank_title">
                    <div class="bank_content">
                        <div class="title_l">
                            <div class="goback">
                                <img v-if="headerInfo.isShow" src="../../assets/goback.png" alt="">
                                <span></span>
                            </div>
                        </div>
                        <!-- 时间 -->
                        <div class="timer">
                            <div class="model_item">
                                {{ time }}
                            </div>
                            <div class="model_item_1">
                                <span>{{ current }}</span>
                                <span>{{ week | weekFilter }}</span>
                            </div>
                        </div>
                        <!-- <span class="title_name">{{ headerInfo.name }}</span> -->
                        <span class="title_name">{{ info }}</span>

                        <div class="title_r">
                            <div class="model">
                            </div>
                            <div class="time" @click="exitLogin">
                                <span class="el-icon-switch-button"></span>
                                <span @click="exitLogin">退出</span>
                                <!-- <label>{{time}}</label> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <Header :data='headerInfo'></Header> -->
            </div>
            <div class="content">
                <!-- 头部 -->
                <div class="header">
                    <div class="t_1">
                        <span class="info">平台注册用户(个)</span>
                        <div class="t_">
                            <!-- <span>{{ platformRegisteredUser.value }}</span> -->
                            <span>12307</span>
                            <span>今日新增:{{ platformRegisteredUser.todayNew }}</span>
                        </div>
                    </div>

                    <div class="t_1" style="cursor: pointer;" @click="groupBtn">
                        <span class="info">GMV累计交易金额(亿)</span>
                        <div class="t_">
                            <!-- <span>{{ totalTradeAmount.value }}</span> -->
                            <span>10.36</span>
                            <span>今日新增:{{ totalTradeAmount.todayNew }}</span>

                        </div>
                    </div>

                    <div class="t_1">
                        <span class="info">累计监管金额(亿)</span>
                        <div class="t_">
                            <!-- <span>{{ totalSuperviseAmount.value }}</span> -->
                            <span>13.54</span>
                            <span>今日新增:{{ totalSuperviseAmount.todayNew }}</span>

                        </div>
                    </div>

                </div>
                <!-- 地图 -->
                <div class="main">
                    <div id="mapBox"></div>
                    <!-- 底部数字 -->
                    <div class="footer">
                        <div class="number">
                            <ul>
                                <li v-for="(item, index) in num_1" :key="index">{{ item }}</li>
                            </ul>
                            <span>牛只当前存栏量(头)</span>
                        </div>
                        <div class="number">
                            <ul>
                                <li v-for="(item, index) in num_2" :key="index">{{ item }}</li>
                            </ul>
                            <span>羊只当前存栏量(只)</span>
                        </div>
                    </div>
                </div>
                <div class="common common_0">
                    <img src="../../assets/data_icon_001.png" alt="" />
                    <div class="txt">
                        <span>省级运营中心(个)</span>
                        <div>
                            <!-- <span>{{ provincialCommandCenter.value }}</span> -->
                            <span>5</span>
                            <span>本年度新增：{{ provincialCommandCenter.yearNew }}</span>
                        </div>
                    </div>
                    <!-- <i class="el-icon-d-arrow-right"></i> -->
                    <img class="image" src="../../assets/right_.png" alt="" />
                </div>
                <div class="common common_1">
                    <img src="../../assets/data_icon_001.png" alt="" />
                    <div class="txt">
                        <span>区域合伙人(人)</span>
                        <div>
                            <!-- <span>{{ areaPartner.value }}</span> -->
                            <span>107</span>
                            <span>本月新增：{{ areaPartner.monthNew }}</span>
                        </div>
                    </div>
                    <!-- <i class="el-icon-d-arrow-right"></i> -->
                    <img class="image" src="../../assets/right_.png" alt="" />
                </div>
                <div class="common common_2">
                    <img src="../../assets/data_icon_001.png" alt="" />
                    <div class="txt">
                        <span>畜牧科技师(人)</span>
                        <div>
                            <!-- <span>{{ liveStockTeacher.value }}</span> -->
                            <span>1083</span>
                            <span>今日新增：{{ liveStockTeacher.todayNew }}</span>
                        </div>
                    </div>
                    <!-- <i class="el-icon-d-arrow-right"></i> -->
                    <img class="image" src="../../assets/right_.png" alt="" />
                </div>
                <div class="common common_3">
                    <img src="../../assets/data_icon_001.png" alt="" />
                    <div class="txt">
                        <span>牛超市(个)</span>
                        <div>
                            <!-- <span>{{ cowSuperMarket.value }}</span> -->
                            <span>8</span>
                            <span>本月新增：{{ cowSuperMarket.monthNew }}</span>
                        </div>
                    </div>
                    <!-- <i class="el-icon-d-arrow-right"></i> -->
                    <img class="image" src="../../assets/right_.png" alt="" />
                </div>
                <div class="common common_4">
                    <img src="../../assets/data_icon_001.png" alt="" />
                    <div class="txt">
                        <span>合作银行(个)</span>
                        <div>
                            <!-- <span>{{ cooperativeBank.value }}</span> -->
                            <span>36</span>
                            <span>本月新增：{{ cooperativeBank.monthNew }}</span>
                        </div>
                    </div>
                    <!-- <i class="el-icon-d-arrow-right"></i> -->
                    <img class="image" src="../../assets/right_.png" alt="" />
                </div>
                <div class="commons common_5">
                    <!-- <i class="el-icon-d-arrow-left"></i> -->
                    <img class="image" src="../../assets/left_.png" alt="" />
                    <div class="txt">
                        <span>服务养殖户(家)</span>
                        <div>
                            <span>{{ serviceFarmer.value }}</span>
                            <span>今日新增：{{ serviceFarmer.todayNew }}</span>
                        </div>
                    </div>
                    <img src="../../assets/data_icon_001.png" alt="" />
                </div>
                <div class="commons common_6">
                    <!-- <i class="el-icon-d-arrow-left"></i> -->
                    <img class="image" src="../../assets/left_.png" alt="" />
                    <div class="txt">
                        <span>服务养殖场(家)</span>
                        <div>
                            <span>{{ serviceFarm.value }}</span>
                            <span>今日新增：{{ serviceFarm.todayNew }}</span>
                        </div>
                    </div>
                    <img src="../../assets/data_icon_001.png" alt="" />
                </div>
                <div class="commons common_7">
                    <!-- <i class="el-icon-d-arrow-left"></i> -->
                    <img class="image" src="../../assets/left_.png" alt="" />
                    <div class="txt">
                        <span>生产资料服务商(家)</span>
                        <div>
                            <span>{{ informationSupplier.value }}</span>
                            <span>本月新增：{{ informationSupplier.monthNew }}</span>
                        </div>
                    </div>
                    <img src="../../assets/data_icon_001.png" alt="" />
                </div>
                <div class="commons common_8">
                    <!-- <i class="el-icon-d-arrow-left"></i> -->
                    <img class="image" src="../../assets/left_.png" alt="" />
                    <div class="txt">
                        <span>屠宰加工企业(个)</span>
                        <div>
                            <span>{{ slaughterEnterprise.value }}</span>
                            <span>本月新增：{{ slaughterEnterprise.monthNew }}</span>
                        </div>
                    </div>
                    <img src="../../assets/data_icon_001.png" alt="" />
                </div>
                <div class="commons common_9">
                    <!-- <i class="el-icon-d-arrow-left"></i> -->
                    <img class="image" src="../../assets/left_.png" alt="" />
                    <div class="txt">
                        <span>合作保险公司(个)</span>
                        <div>
                            <span>{{ insuranceCompany.value }}</span>
                            <span>本月新增：{{ insuranceCompany.monthNew }}</span>
                        </div>
                    </div>
                    <img src="../../assets/data_icon_001.png" alt="" />

                </div>
            </div>
            <!-- GMV累计交易金额弹出层 -->
            <group ref="group"></group>
        </div>
    </Main>
</template>

<script>
import Main from "@/components/main.vue";
import group from "@/views/group/index.vue";
// import Header from "../../components/header.vue";
export default {
    components: {
        Main,
        group
        // Header,
    },
    data() {
        return {
            // shows:false,
            info: '',
            headerInfo: {},
            userInfo: {},
            // myKey: '',
            num_1: [0],
            num_2: [0],
            // 平台注册用户
            platformRegisteredUser: {},
            totalTradeAmount: {}, // GMV累计交易金额(亿)
            totalSuperviseAmount: {},// 累计监管金额(亿)
            provincialCommandCenter: {},// 省级运营中心 
            areaPartner: {},// 区域合伙人 
            liveStockTeacher: {},//畜牧科技师
            cowSuperMarket: {},//牛超市
            cooperativeBank: {},//合作银行
            serviceFarmer: {},//服务养殖户
            serviceFarm: {},//服务养殖场
            informationSupplier: {},//生产资料服务商
            slaughterEnterprise: {},//屠宰加工企业
            insuranceCompany: {},//合作保险银行
            time: null,
            current: null,
            week: null,
            timer: null//定时器
        };
    },
    created() {
        // this.myKey = this.$route.params.myKey
        // this.time = new Date()
        this.getTime()
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.getList()//初始化调用接口
    },
    mounted() {
        this.getMap()//获取地图数据
    },
    // 销毁定时器
    destroyed() {
        clearInterval(this.timer)
    },
    // 日期过滤
    filters: {
        weekFilter: (val) => {
            if (val == 0) return '星期天'
            if (val == 1) return '星期一'
            if (val == 2) return '星期二'
            if (val == 3) return '星期三'
            if (val == 4) return '星期四'
            if (val == 5) return '星期五'
            if (val == 6) return '星期六'

        }
    },
    methods: {
        groupBtn() {
            console.log(222);
            // this.shows = true    
            this.$refs.group.showModel()
        },
        getList() {
            this.$http({
                url: 'screenapp-service/baseBigScreen/select',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                    parentId: "0",
                    menuMark: "5"
                },
            }).then(res => {
                const data = res.data
                if (data.code == 200) {
                    var screenData = JSON.parse(data.result.screenData)
                    console.log(screenData);
                    this.info = data.result.screenName
                    // this.num_1 = screenData.cowQuantity
                    // this.num_2 = screenData.sheepQuantity
                    this.num_1 = screenData.cowQuantity.toString().split('')
                    this.num_2 = screenData.sheepQuantity.toString().split('')
                    this.platformRegisteredUser = screenData.platformRegisteredUser
                    this.totalTradeAmount = screenData.totalTradeAmount
                    this.totalSuperviseAmount = screenData.totalSuperviseAmount
                    this.provincialCommandCenter = screenData.provincialCommandCenter
                    this.areaPartner = screenData.areaPartner
                    this.liveStockTeacher = screenData.liveStockTeacher
                    this.cowSuperMarket = screenData.cowSuperMarket
                    this.cooperativeBank = screenData.cooperativeBank
                    this.serviceFarmer = screenData.serviceFarmer
                    this.serviceFarm = screenData.serviceFarm
                    this.informationSupplier = screenData.informationSupplier
                    this.slaughterEnterprise = screenData.slaughterEnterprise
                    this.insuranceCompany = screenData.insuranceCompany
                }
            })
        },
        getTime() {
            // var year = new Date().getYear();//获取当前年份（2位）
            // var fullYear = new Date().getFullYear();//获取当前完整年分（4位）
            // var month = new Date().getMonth();//获取当前月份（0~11，0代表1月）
            // var day = new Date().getDate();//获取当前日（1-31日）
            // var h = new Date().getHours();//获取当前小时（0~23）
            // var m = new Date().getMinutes();//获取当前分钟数（0~59）
            // var s = new Date().getSeconds();//获取当前秒数（0~59）
            // var ss = new Date().getMilliSeconds();//获取当前毫秒数（0-999）
            // var currentTime = new Date().toLocaleString(); //获取日期与时间
            this.current = new Date().toLocaleDateString().replace(/\//g, '-');//获取当前日期（“年/月/日”）
            this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
            if (this.timer) {
                clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
                var time = new Date().toLocaleTimeString();//获取当前时间
                this.time = time
            }, 1000)
        },
        // 退出
        exitLogin() {
            window.localStorage.removeItem('mapfileUrl')
            window.localStorage.removeItem('NMYDATAUSERINFO')
            window.localStorage.removeItem('NMYDATAASSTSTOKEN')
            // this.$router.push({ path: '/login' })
            this.$router.push({ path: '/nmlogin' })
        },
        // getData() {
        //     this.$http({
        //         url: 'screenapp-service/baseBigScreen/select/other',
        //         //请求方式
        //         method: 'post',
        //         //传递的参数
        //         data: {
        //             "parentId": "4",
        //             "menuMark": "3",
        //             "dataFlag": "0",
        //             deptId: this.userInfo.dept.deptId,
        //         },
        //     }).then(res => {
        //         const data = res.data;
        //         if (res.data.code === 200) {
        //             const screenData = JSON.parse(data.result.screenData)
        //             console.log(screenData)
        //             this.draw(this.region, screenData.areaDis)
        //         } else {
        //             this.$message.error(data);
        //         }
        //     })
        // },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    // console.log(res,'rers');
                    this.region = res.data.result.json;
                    // this.getData()
                    this.draw(this.region)
                }
            })
        },
        // draw(geoJson) {
        //     // 基于准备好的dom，初始化echarts实例
        //     var chart = this.$echarts.init(document.getElementById("mapBox"));
        //     geoJson.features.forEach((item) => {
        //         item['properties']['cp'] = item.properties.center
        //     })
        //     // this.$echarts.registerMap("china", geoJson);
        //     // 隐藏动画加载效果。
        //     chart.hideLoading();
        //     chart.setOption({
        //         // grid: {
        //         //     show: true,
        //         //     height:'800px',
        //         //     containLabel: true,
        //         // },
        //         tooltip: {
        //             // 提示框
        //             trigger: "item",
        //             borderColor: "rgba(33,80,231,1)",
        //             borderWidth: 2,
        //             padding: 5,
        //             backgroundColor: "rgba(7, 70, 73, 0.79)",
        //             extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
        //             formatter: function (params) {
        //                 return `<p>
        //                     <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.name
        //                     }：${params.name || 0}</span>

        //                 </p>`;
        //             },
        //         },
        //         series: [
        //             {
        //                 type: "map", // 系列类型
        //                 name: "map", // 系列名称
        //                 zoom: 1.2,
        //                 map: "china", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
        //                 // data: data,
        //                 label: {
        //                     // properties.cp
        //                     // 标签的相关设置
        //                     // show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
        //                     // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
        //                     position: 'top',
        //                     // offset: [-10, 5],
        //                     textStyle: {
        //                         // 标签的字体样式
        //                         color: "white", // 地图初始化区域字体颜色
        //                         fontSize: 8, // 字体大小
        //                         opacity: 1, // 字体透明度
        //                         backgroundColor: "rgba(0,23,11,0)", // 字体背景色
        //                     },
        //                     // align: 'center',
        //                     // verticalAlign: 'middle'
        //                     // normal: {
        //                     //     show: true,
        //                     //     color: 'rgba(5, 176, 220, 1)',
        //                     //     fontSize: 1, //此处字体需做兼容适配

        //                     //     align: 'left',
        //                     //     verticalAlign: 'middle',
        //                     //     position: 'inside',
        //                     //     distance: 15,
        //                     // },
        //                     // emphasis: {
        //                     //     show: true,
        //                     //     color: '#ececec'
        //                     // }
        //                 },
        //                 itemStyle: {
        //                     // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
        //                     color: "rgba(33,80,231,1)", // 地图板块的颜色
        //                     // color: 'rgba(255, 255, 255, 0.01)',
        //                     opacity: 1, // 图形的不透明度 [ default: 1 ]
        //                     borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
        //                     borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
        //                     normal: { // 默认地图区域样式
        //                         // areaColor: 'rgba(33,80,231,1)',
        //                         areaColor: 'rgba(255, 255, 255, 0.01)',
        //                         borderColor: "#4ECEE6",
        //                         borderWidth: 1,
        //                         shadowColor: "#2C99F6",
        //                         shadowOffsetY: 0,
        //                         shadowBlur: 25,
        //                     },
        //                 },

        //                 emphasis: {
        //                     // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
        //                     label: {
        //                         // label高亮时的配置
        //                         show: true,
        //                         textStyle: {
        //                             color: "#fff", // 高亮时标签颜色变为 白色
        //                             fontSize: 15, // 高亮时标签字体 变大
        //                         },
        //                         // formatter : function(params) {
        //                         //     console.log(params)
        //                         // }
        //                     },
        //                     itemStyle: {
        //                         "areaColor": "#1E88E5"
        //                     }
        //                 }
        //             },
        //             {
        //                 type: 'effectScatter',
        //                 name: '哈哈哈',
        //                 effectType: 'ripple',
        //                 coordinateSystem: 'geo',
        //                 data: [{ name: '123', value: [111.12, 111.132] }, { name: '123', value: [101.12, 111.132] }]

        //             }
        //         ],
        //     });
        //     window.addEventListener('resize', () => {
        //         chart.resize()
        //     })
        // },


        draw(geoJson) {
            // 基于准备好的dom，初始化echarts实例
            // console.log(data)
            var chart = this.$echarts.init(document.getElementById("mapBox"));
            geoJson.features.forEach((item) => {
                item['properties']['cp'] = item.properties.center
            })
            // this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            chart.hideLoading();
            chart.setOption({
                // tooltip: {
                //     // 提示框
                //     trigger: "item",
                //     backgroundColor: 'rgba(11, 15, 56, 1)',
                //     // backgroundColor: '#0043ff',
                //     borderColor: 'rgba(18, 36, 132, 1)',
                //     borderWidth: 2,
                //     textStyle: {
                //         color: '#fff',
                //     },
                //     padding: 5,
                //     extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                //     formatter: function (params) {
                //         return `<p>
                //                   <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.name
                //             }： ${0} 人</span>

                //               </p>`;
                //         // return params.name
                //     },
                // },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    padding: 5,
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        return `<p>
                                  <span style="font-size: 14px; font-weight: normal;">${params.name
                            }： ${0} 人</span>

                              </p>`;
                        // return params.name
                    },
                },
                // series: [
                geo: {
                    show: true,
                    // roam: true,
                    type: "map", // 系列类型
                    name: "map", // 系列名称
                    zoom: 1.2,
                    map: "china", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                    data: [
                        {
                            "name": "西吉县",
                            "value": 405,
                            "totalServeCustomer": 405, // 累计服务客户(家)
                            "livestockMaster": 39, // 畜牧科技师(人)
                            "liveAnimal": 21289, // 当前存栏活畜(头)
                            "totalTradeAmount": 30.76, // 累计交易金额(亿)
                            "position": [ // 坐标
                                105.72911,
                                35.96385
                            ]
                        },
                        {
                            "name": "泾源县",
                            "value": 1405,
                            "totalServeCustomer": 405,
                            "livestockMaster": 39,
                            "liveAnimal": 21289,
                            "totalTradeAmount": 30.76,
                            "position": [
                                106.33067,
                                35.49823
                            ]
                        }],
                    label: {
                        // properties.cp
                        // 标签的相关设置
                        show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                        // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                        position: 'top',
                        // offset: [-10, 5],
                        textStyle: {
                            // 标签的字体样式
                            color: "white", // 地图初始化区域字体颜色
                            fontSize: 12, // 字体大小
                            opacity: 1, // 字体透明度
                            backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                        },
                        // align: 'center',
                        // verticalAlign: 'middle'
                        // normal: {
                        //     show: true,
                        //     color: 'rgba(5, 176, 220, 1)',
                        //     fontSize: 1, //此处字体需做兼容适配

                        //     align: 'left',
                        //     verticalAlign: 'middle',
                        //     position: 'inside',
                        //     distance: 15,
                        // },
                        // emphasis: {
                        //     show: true,
                        //     color: '#ececec'
                        // }
                    },

                    itemStyle: {
                        // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                        // color: "rgba(33,80,231,1)", // 地图板块的颜色
                        // color: '#082263',
                        color: '#08185A',
                        opacity: 1, // 图形的不透明度 [ default: 1 ]
                        borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                        borderColor: "#10439C", // 图形描边的颜色。[ default: #333 ]
                        // normal: { // 默认地图区域样式
                        //     // areaColor: 'rgba(33,80,231,1)',
                        //     aeraColor:'#021355',
                        //     borderColor: "#4ECEE6",
                        //     borderWidth: 1,
                        //     shadowColor: "#2C99F6",
                        //     shadowOffsetY: 0,
                        //     shadowBlur: 25,
                        // },
                    },
                    select: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        },
                        label: { color: '#fff' },
                    },
                    blur: {
                        itemStyle: {
                            areaColor: "#1E88E5",
                            borderColor: "#21bde6",
                            borderWidth: "1"
                        }
                    },
                    emphasis: {
                        // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                        label: {
                            // label高亮时的配置
                            show: true,
                            textStyle: {
                                color: "#fff", // 高亮时标签颜色变为 白色
                                fontSize: 15, // 高亮时标签字体 变大
                            },
                            // formatter : function(params) {
                            //     console.log(params)
                            // }     
                        },
                        itemStyle: {
                            "areaColor": "#1E88E5"
                        }
                    },

                    groundPlane: {
                        // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                        show: false, // 是否显示地面。[ default: false ]
                        color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                    },
                    light: {
                        // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                        main: {
                            // 场景主光源的设置，在 globe 组件中就是太阳光。
                            color: "#fff", //主光源的颜色。[ default: #fff ]
                            intensity: 1.2, //主光源的强度。[ default: 1 ]
                            shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                            shadowQuality: "high", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                            alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                            beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                        },
                    },
                    // top:'20%',
                    viewControl: {
                        // 用于鼠标的旋转，缩放等视角控制。
                        // projection: "orthographic", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                        // autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                        // autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                        // autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                        // autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                        // damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                        // rotateSensitivity: 1, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                        // zoomSensitivity: 1, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                        // panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                        // panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        // rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                        // orthographicSize: 60,
                        distance: 125, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                        // minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                        // maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                        alpha: 90, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                        beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                        // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                        // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                        // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                        // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                        // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                        // animation: true, // 是否开启动画。[ default: true ]
                        // animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                        // animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                    },
                },
                // ]
                series: [
                    {
                        type: 'map',
                        geoIndex: 0,
                        // data: [12, 32, 300],
                        data: [
                            {
                                "name": "西吉县",
                                "value": 405,
                                "totalServeCustomer": 405, // 累计服务客户(家)
                                "livestockMaster": 39, // 畜牧科技师(人)
                                "liveAnimal": 21289, // 当前存栏活畜(头)
                                "totalTradeAmount": 30.76, // 累计交易金额(亿)
                                "position": [ // 坐标
                                    105.72911,
                                    35.96385
                                ]
                            },
                            {
                                "name": "泾源县",
                                "value": 4058,
                                "totalServeCustomer": 405,
                                "livestockMaster": 39,
                                "liveAnimal": 21289,
                                "totalTradeAmount": 30.76,
                                "position": [
                                    106.33067,
                                    35.49823
                                ]
                            }],
                        itemStyle: {
                            normal: {
                                color:'#fff'
                            }
                        },

                    },
                    {
                        type: 'effectScatter',
                        name: '200',
                        coordinateSystem: 'geo',
                        effectType: 'ripple',
                        rippleEffect: {
                            color: '#00FFFF',
                            number: 3,
                            scale: 5,
                            brushType: 'stroke'
                        },

                        data: [
                            {
                                name: '武汉', value: [114.31, 31.56]
                            },
                            {
                                name: '湖北', value: [87.617733, 43.792818]
                            },
                            {
                                name: '北京', value: [103.823557, 36.05]
                            },
                            {
                                name: '上海', value: [111.765617, 40.817498]
                            },
                            {
                                name: '上海', value: [101.778916, 36.623178]
                            },
                            {
                                name: '上海', value: [106.15, 33.33]
                            },



                        ]
                    }
                ],
                visualMap: {
                    type: 'piecewise',
                    // show: true,
                    // min: 0,
                    // max: 200, //控制根据返回值  控制数量
                    right: 15,
                    bottom: 200,
                    // showLabel: !0,
                    // text: ['High', 'Low'],
                    // realtime: false,
                    // calculable: true,
                    // // inRange: {
                    // //     color: ['#11366a', '#EFFFA8', '#EFFFA8', '#FC8506', '#F1411D']  //显示颜色
                    // // },
                    // continuous: {
                    //     type: 'piecewise',
                    itemSymbol: 'circle',
                    itemWidth: 8,
                    itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: [{
                        gt: 400,
                        label: "400以上",
                        color: "#6b3e35"
                    }, {
                        gte: 301,
                        lte: 400,
                        label: "301 - 400",
                        color: "#4a383f"
                    }, {
                        gte: 201,
                        lte: 300,
                        label: "201- 300",
                        color: "#303345"
                    }, {
                        gte: 101,
                        lte: 200,
                        label: "101- 200",
                        color: "#192f4d"
                    }, {
                        gte: 0,
                        lte: 100,
                        label: "0 - 100",
                        color: "#112e50"
                    }],
                    // },
                },
                // visualMap: {
                //     show: false,
                //     min: 0,
                //     max: 300,
                //     inRange: {
                //         color: ['white', 'red']
                //     }
                // },
                // legend: {        //图例组件
                //     right: 0,
                //     bottom: 320,
                //     // data: ['强', '中', '弱'],
                //     textStyle: {
                //         color: '#ccc'
                //     }
                // },
            });
        },
    }

}
</script>

<style lang="scss" scoped>
.main {
    background: url('../../assets/背景.png');
    background-size: 100% 100%;
    // width: 24rem;
    // height: 13.5rem;

    .bank_title {
        .bank_content {
            position: relative;
            height: 1rem;
            background-image: url("../../assets/data_title_bg.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .timer {
                position: absolute;
                // left: 1.04rem;
                left: .5rem;
                top: .25rem;
                display: flex;
                justify-content: center;
                align-items: center;

                .model_item {
                    // width: 1.7rem;
                    // height: 0.52rem;
                    font-size: 0.38rem;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                    font-weight: bold;
                    color: #fff;
                    cursor: pointer;
                }

                .model_item_1 {
                    width: 2.76rem;
                    height: 0.27rem;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 0.3rem;
                    margin-left: .5rem;

                    span:nth-child(2) {
                        margin-left: .2rem;
                    }
                }
            }

            .title_name {
                font-size: 0.4rem;
                font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
                font-weight: 500;
                color: #FFFFFF;
            }

            .title_l,
            .title_r {
                width: 7.75rem;
                display: flex;
                justify-content: space-between;
                padding-bottom: 0.24rem;
                margin-right: .5rem;

                .model {
                    display: flex;
                }

                .current_nav_l {
                    background-image: url("../../assets/btn_bg_003.png");
                }

                .current_nav {
                    background-image: url("../../assets/btn_bg_2.png") !important;
                }
            }

            .title_l {
                .goback {
                    // margin-top: 0.49rem;
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 0.14rem;
                    height: 0.23rem;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }

                span {
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: rgba(0, 224, 219, 0.97);
                }
            }

            .title_r {
                .time {
                    display: flex;
                    align-items: center;
                    // padding-right: 0.11rem;
                    cursor: pointer;
                }

                .time label {
                    font-size: 0.3rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #2C75FD;
                    margin-top: 0.15rem;
                }

                .time span {
                    font-size: 0.3rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #FFFFFF;
                    cursor: pointer;
                    padding-right: 0.1rem;
                }


            }
        }

        img {
            height: 0.45rem;
        }

    }

    .content {
        position: relative;
        width: 100%;
        height: 11.8rem;
        // height: 12.5rem;
        // height: 12rem;
        margin-top: 0.5rem;
        padding: 0 0.24rem;

        .header {
            height: 1.88rem;
            // height: 2.1rem;
            display: flex;
            justify-content: center;
            // margin-top: 0.88rem;

            .t_1 {
                .info {
                    display: block;
                    min-width: 1.8rem;
                    height: 0.25rem;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 0.25rem;
                    text-align: center;
                }

                .t_ {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    min-width: 1.99rem;
                    height: 1rem;
                    // margin-right: 2rem;
                    text-align: center;
                    color: #ffbb00;
                    background: rgba(255, 255, 255, 0.01);
                    box-shadow: inset 0rem 0rem 0.2rem 0rem rgba(14, 95, 255, 0.5789);
                    opacity: 1;
                    border: 0.01rem solid rgba(50, 197, 255, 0.3856);
                    margin-top: 0.2rem;

                    span:nth-child(1) {
                        margin-top: 0.2rem;
                        font-size: 0.5rem;
                    }

                    span:nth-child(2) {
                        font-size: 0.2rem;
                        margin-top: 0.25rem;
                        color: #d1d6e1;
                    }
                }
            }

            .t_1:nth-child(1) {
                margin-right: 1.5rem;
            }

            .t_1:nth-child(3) {
                margin-left: 1.5rem;
            }

        }

        .main {
            position: relative;
            width: 14rem;
            // height: 10rem;
            // width: 12.9rem;
            // height: 9.5rem;
            height: 9rem;
            margin: auto;
            margin-top: .2rem;
            overflow: hidden;
            background: url('../../assets/圆弧.png');
            background-size: 100% 100%;

            #mapBox {
                // width: 9.36rem;
                // width: 11.56rem;
                // height: 11.56rem;
                width: 12.9rem;
                height: 9.5rem;
                // z-index: 10;
                // height: 7.66rem;
            }

            .footer {
                position: absolute;
                left: 2.6rem;
                bottom: .3rem;
                // height: 2.32rem;
                display: flex;
                justify-content: center;

                .number {
                    // width: 230px;
                    // height: 100%;
                    // text-align: center;

                    ul {
                        display: flex;
                        justify-content: space-evenly;
                        margin-top: .375rem;

                        li {
                            text-align: center;
                            width: 0.5rem;
                            height: 0.5rem;
                            background: rgba(255, 255, 255, 0.2);
                            border-radius: 0rem 0rem 0rem 0rem;
                            opacity: 1;
                            border: 0.01rem solid rgba(255, 255, 255, 0.2);
                            font-size: 0.38rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #05FBFE;
                            line-height: 0.5rem;
                            letter-spacing: 1px;
                            margin-left: .1rem;
                        }
                    }

                    span {
                        display: block;
                        margin-top: 0.2rem;
                        // width: 2.05rem;
                        height: 0.23rem;
                        font-size: 0.23rem;
                        font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                        font-weight: 100 !important;
                        color: #FFFFFF;
                        line-height: 0.23rem;
                        text-align: center;
                    }
                }

                .number:nth-child(2) {
                    margin-left: 1.41rem;
                }

            }
        }

        .common {
            position: absolute;
            height: 1.63rem;
            left: .5rem;
            display: flex;
            align-items: center;
            background: url('../../assets/btn_bg_1.png');
            background-size: 100% 100%;

            img {
                width: .67rem;
                height: .67rem;
                margin-left: .29rem;
            }

            .txt {
                min-width: 2.5rem;
                display: flex;
                flex-direction: column;
                margin-left: .22rem;

                span {
                    margin-bottom: 0.4rem;
                    min-width: 1.35rem;
                    height: 0.18rem;
                    font-size: 0.18rem;
                    font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                    font-weight: 400;
                    color: #D8DFFE;
                    line-height: 0.18rem;
                }

                div {
                    span:nth-child(1) {
                        font-size: 0.43rem;
                        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                        font-weight: bold;
                        color: #05FBFE;
                        padding-right: .1rem;
                    }
                }

            }

            .image {
                width: 0.2rem;
                height: 0.2rem;
            }

            i {
                display: block;
                width: 0.2rem;
                font-weight: 700;
                // height: 0.4rem;
                // background: linear-gradient(270deg, rgba(61, 127, 255, 0) 0%, #3D7FFF 50%, #66FFFF 100%);
                color: rgba(50, 197, 255, 0.3856);
                cursor: pointer;

                // opacity: 1;
            }


        }

        .commons {
            height: 1.63rem;
            position: absolute;
            right: .5rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: url('../../assets/btn_bg_1.png');
            background-size: 100% 100%;

            img {
                width: .67rem;
                height: .67rem;
                margin-right: .29rem;
            }

            .txt {
                min-width: 2.5rem;
                display: flex;
                flex-direction: column;
                // margin-right: .22rem;

                span {
                    margin-bottom: 0.4rem;
                    min-width: 1.35rem;
                    height: 0.18rem;
                    font-size: 0.18rem;
                    font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                    font-weight: 400;
                    color: #D8DFFE;
                    line-height: 0.18rem;
                }

                div {
                    span:nth-child(1) {
                        font-size: 0.43rem;
                        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
                        font-weight: bold;
                        color: #05FBFE;
                        padding-right: .2rem;
                    }
                }
            }

            .image {
                width: 0.2rem;
                height: 0.2rem;
            }

            i {
                display: block;
                width: 0.2rem;
                font-weight: 700;
                // height: 0.4rem;
                // background: linear-gradient(270deg, rgba(61, 127, 255, 0) 0%, #3D7FFF 50%, #66FFFF 100%);
                color: rgba(50, 197, 255, 0.3856);
                cursor: pointer;
                // opacity: 1;
            }
        }

        .common_0 {
            width: 6.35rem;
            // left: 1.06rem;
            top: 1.7rem;
            background: url('../../assets/jibg_01.png');
            background-size: 100% 100%;

            // i {
            //     margin-left: 1.5rem;
            // }

            .image {
                margin-left: 1.5rem;
            }
        }

        .common_1 {
            width: 4.76rem;
            // left: 1.06rem;
            top: 3.7rem;
            background: url('../../assets/jibg_02.png');
            background-size: 100% 100%;

            // i {
            //     margin-left: .7rem;
            // }
            .image {
                margin-left: .35rem;
            }
        }

        .common_2 {
            width: 4.1rem;
            // left: 1.06rem;
            top: 5.7rem;
            background: url('../../assets/jibg_03.png');
            background-size: 100% 100%;

            // i {
            //     color: red;
            //     margin-left: 1.2rem;
            // }
            .image {
                margin-left: .01rem;
            }
        }

        .common_3 {
            width: 4.72rem;
            // left: 1.06rem;
            top: 7.7rem;
            background: url('../../assets/jibg_04.png');
            background-size: 100% 100%;

            // i {
            //     margin-left: .8rem;
            // }
            .image {
                margin-left: .35rem;
            }
        }

        .common_4 {
            width: 6.29rem;
            // left: 1.06rem;
            top: 9.7rem;
            background: url('../../assets/jibg_05.png');
            background-size: 100% 100%;

            // i {
            //     margin-left: 2.2rem;
            // }
            .image {
                margin-left: 1.5rem;
            }
        }

        .common_5 {
            width: 6.35rem;
            // right: 1.06rem;
            top: 1.7rem;
            background: url('../../assets/jibg_06.png');
            background-size: 100% 100%;

            // .txt {
            //     margin-right: .2rem;
            // }

            // i {
            //     margin-right: 1.2rem;
            // }
            .image {
                margin-right: 1.5rem;
            }

        }

        .common_6 {
            width: 4.76rem;
            // right: 1.06rem;
            top: 3.7rem;
            background: url('../../assets/jibg_07.png');
            background-size: 100% 100%;

            .txt {
                margin-right: .2rem;
            }

            // i {
            //     margin-right: .4rem;
            // }
            .image {
                margin-right: .4rem;
            }
        }

        .common_7 {
            width: 4.1rem;
            // right: 1.06rem;
            top: 5.7rem;
            background: url('../../assets/jibg_08.png');
            background-size: 100% 100%;

            .txt {
                margin-right: .2rem;
            }

            // i {
            //     margin-right: .6rem;
            // }
            .image {
                margin-right: .1rem;
            }
        }

        .common_8 {
            width: 4.72rem;
            // right: 1.06rem;
            top: 7.7rem;
            background: url('../../assets/jibg_09.png');
            background-size: 100% 100%;

            .txt {
                margin-right: .2rem;
            }

            // i {
            //     margin-right: .9rem;
            // }
            .image {
                margin-right: .4rem;
            }
        }

        .common_9 {
            width: 6.29rem;
            // right: 1.06rem;
            top: 9.7rem;
            background: url('../../assets/jibg_10.png');
            background-size: 100% 100%;

            .txt {
                margin-right: .2rem;
            }

            // i {
            //     margin-right: 2.2rem;
            // }
            .image {
                margin-right: 1.5rem;
            }
        }
    }
}
</style>